import ArrowDownIcon from "@pages/profile-v2/assets/icons/ArrowDownIcon.jsx";
import ConfirmIcon from "@pages/profile-v2/assets/icons/ConfirmIcon.jsx";
import moment from "moment";
import React, { useEffect, useState } from "react";
import defaultCasinoIcon from "../../../../../../casino/assets/backgrounds/mars-casino-icon.webp";
import {
	BonusItemWrapper,
	ButtonText,
	ContentButton,
	ContentInfo,
	Date,
	DateWrapper,
	Detail,
	DetailWrapper,
	DetailsButton,
	FSContentButton,
	FSContentTitle,
	FSItemContent,
	FSItemContentWrapper,
	FSItemImg,
	Info,
	InfoTitle,
	ItemContent,
	ItemHeader,
} from "./elements";

export const getFreespinGameData = (limits) => {
	return Object.keys(limits)
		.filter((key) => limits[key].isAllowed)
		?.map((key) => limits[key])[0];
};

const BonusItem = ({ data, index, translate, openIndex, setOpenIndex, onConfirm, loading }) => {
	const getBonusName = (name) => {
		return name === "LUCK BOX TRY" ? "LUCKY BOX BONUS" : name;
	};

	const getAllowedTargets = (limits) => {
		return Object.keys(limits).filter((i) => limits[i].isAllowed);
	};

	const type = data.bonusDetail.instruction.type;
	const name = getBonusName(data?.bonusDetail?.name);
	const startDate = moment(Number(data?.timestamp)).format("DD/MM/YYYY HH:mm");
	const endDate = moment(Number(data?.timestamp))
		.add(data?.bonusDetail?.claimExpirationDays, "days")
		.format("DD/MM/YYYY HH:mm");
	const allowedTargets = getAllowedTargets(data.bonusDetail.limits);
	const amount = data.amountToDisplay.value;
	const currency = data.amountToDisplay.currency;
	const freespinGameData = getFreespinGameData(data.bonusDetail.limits);
	const areDetailsOpen = openIndex === index;

	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	useEffect(() => {
		const handleResize = () => setWindowWidth(window.innerWidth);
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const shouldShowDetails = windowWidth >= 768 || areDetailsOpen;
	const renderFreespin = () => {
		return (
			<BonusItemWrapper>
				<ItemHeader>
					{freespinGameData?.games[0]?.provider?.toUpperCase()} |{" "}
					{freespinGameData.games[0]?.remote_name?.toUpperCase()}
				</ItemHeader>
				<FSItemContentWrapper>
					<FSItemImg
						src={
							freespinGameData?.games[0]?.game_icon_url ||
							freespinGameData?.games[0]?.icon_high ||
							freespinGameData?.games[0]?.icon_custom_url ||
							defaultCasinoIcon
						}
					/>
					<FSItemContent>
						<FSContentTitle>
							<span>{amount}</span> <span>{translate("SPIN")}</span>
						</FSContentTitle>
						<FSContentButton
							disableButton={!!loading}
							onClick={() => onConfirm(data)}>
							<ConfirmIcon />
							{translate("Confirm")}
						</FSContentButton>
					</FSItemContent>
				</FSItemContentWrapper>
				{shouldShowDetails ? (
					<DetailWrapper>
						<DateWrapper>
							<Date>
								{translate("Start")}: {startDate}
							</Date>
							<Date>
								{translate("Last")}: {endDate}
							</Date>
						</DateWrapper>
					</DetailWrapper>
				) : null}
				{windowWidth < 768 && (
					<DetailsButton
						rotate={areDetailsOpen}
						onClick={() => setOpenIndex(areDetailsOpen ? -1 : index)}>
						<ButtonText>
							{!areDetailsOpen ? translate("DETAILS") : translate("HIDE")}
						</ButtonText>
						<ArrowDownIcon />
					</DetailsButton>
				)}
			</BonusItemWrapper>
		);
	};

	const renderBonus = () => {
		return (
			<>
				<BonusItemWrapper>
					<ItemHeader>{name}</ItemHeader>
					<ItemContent>
						<ContentInfo>
							<InfoTitle>BONUS:</InfoTitle>
							<Info>
								{amount} {currency}
							</Info>
						</ContentInfo>
						<ContentButton
							disableButton={!!loading}
							onClick={() => onConfirm(data)}>
							<ConfirmIcon />
							{translate("Confirm")}
						</ContentButton>
					</ItemContent>
					{shouldShowDetails ? (
						<DetailWrapper>
							<Detail>{`Available in ${allowedTargets
								.map((i) => i.toUpperCase())
								.join(", ")}`}</Detail>
							<DateWrapper>
								<Date>
									{translate("Start")}: {startDate}
								</Date>
								<Date>
									{translate("Last")}: {endDate}
								</Date>
							</DateWrapper>
						</DetailWrapper>
					) : null}
					{windowWidth < 768 && (
						<DetailsButton
							rotate={areDetailsOpen}
							onClick={() => setOpenIndex(areDetailsOpen ? -1 : index)}>
							<ButtonText>
								{!areDetailsOpen ? translate("DETAILS") : translate("HIDE")}
							</ButtonText>
							<ArrowDownIcon />
						</DetailsButton>
					)}
				</BonusItemWrapper>
			</>
		);
	};
	return type === "Freespin" ? renderFreespin() : renderBonus();
};

export default BonusItem;
